import {Order, Task, TaskExecuteAction,  TaskState} from "@/types";
import {executeTask} from "@/store/services/task/workflow";
import {deepClone} from "@/utils";
import Notify from 'quasar/src/plugins/Notify.js';;
import i18n from "@/i18n";

export async function executeArchiveOrder(taskState: TaskState, order: Order, task: Task) {
    const archiveOrder = deepClone(taskState.archivingOrderModule.bind)
    const {
        decisionDate,
        comment,
    } = archiveOrder
    // TODO verify if need to save the decision on the database
    const taskExecuteAction: TaskExecuteAction = {
        taskId: task.taskId || '',
        variables: {
            orderStatus: { value: "ARCHIVING", type: "String" },
            comment: {
                type: "String",
                value: comment
              }
        }
    }
    try {
        const result = await executeTask(taskExecuteAction);
        Notify.create({
            message: i18n.global.t('task.executed'),
            color: 'positive'
        });
        return result;
    } catch (e) {
        console.error(e)
        return Promise.reject(e)
    }
}
